import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-signout',
    templateUrl: './signout.component.html',
    styleUrls: ['./signout.component.scss'],
    standalone: true
})
export class SignoutComponent implements OnInit {
    constructor(private readonly _auth: AuthService) {}

    ngOnInit(): void {
        this._auth.signOut();
    }
}
